<template>
  <base-content-block :back-name="'hospitals'">
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <div v-if="loading">
        <base-spinner></base-spinner>
      </div>
      <div v-else-if="!hospital">{{ $t('src/pages/hospitalsedit.554') }}</div>
      <div v-else>
        <hospital-form v-model="hospital" :saving="saving" @submit="save"></hospital-form>
      </div>
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { contentTpl } from '@/mixins/content-tpl.js'
import { savedMessage } from '@/mixins/saved-message.js'

export default {
  name: 'HospitalsEdit',
  mixins: [contentTpl, savedMessage],
  components: {
    HospitalForm: () => import('@/components/HospitalForm.vue'),
    BaseSpinner: () => import('@/base/BaseSpinner.vue')
  },
  data: () => ({
    hospital: null,
    saving: false,
    loading: true
  }),
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.getHospital()
      }
    }
  },
  mounted() {
    this.getHospital()
  },
  methods: {
    getHospital() {
      this.hospital = null
      http
        .get('/hospitals/' + this.id, {
          headers: {
            redirect404: true
          }
        })
        .then(response => {
          this.hospital = response.data
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false))
    },
    save() {
      this.saving = true

      http
        .patch('/hospitals/' + this.id, this.hospital)
        .then(response => response.data)
        .then(data => {
          this.hospital = data
          this.$emit('saved:data')
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
